import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      // eslint-disable-next-line camelcase
      visit_documentTemplate: {
         ICD10: 'ICD-10',
         add: 'Dodaj',
         addDiagnosis: 'Dodaj rozpoznanie',
         back: 'Wstecz',
         cancel: 'Anuluj',
         confirmAndPrint: 'Zatwierdź i drukuj',
         confirmAndShare: 'Zatwierdź i udostępnij',
         confirmingDocument: 'Zatwierdzanie dokumentu',
         createdAndSentPatientRecords: 'Utworzono i wysłano dokumentację pacjenta',
         diagnosis: 'Rozpoznanie',
         documentTemplateDraftSaved: 'Wersja robocza druku została zapisana.',
         documentTemplateFetchError: 'Nie udało się pobrać szablonu dokumentu.',
         fillICD10OrDiagnosisName: 'Uzupełnij kod ICD-10 lub nazwę choroby...',
         name: 'Nazwa',
         selectDiagnosis: 'Wybierz rozpoznanie',
         send: 'Wyślij',
         sendingDocumentation: 'Wysyłanie dokumentacji',
         sentDocumentationToPatientAndSmsMessageWithPassword:
            'Wysłaliśmy dokumentację do pacjenta oraz wiadomość SMS z poniższym hasłem.',
         shareRecordsWithPatient: 'Udostępnij dokumentację pacjentowi',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, 'visit_documentTemplate');
